<template>
    <div id="app">
        <div v-cloak :class="$route.name">
        <header id="header" class="header-effect-shrink">
            <div class="header-body">
                <div class="header-container container">
                    <div class="header-row">
                        <div class="header-column">
                            <div class="header-row">
                                <div class="header-logo">
                                    <router-link to="/legacy/"><img alt="code::dive" width="250" src="./assets/logo.svg"></router-link>
                                </div>
                            </div>
                        </div>
                        <div class="header-column justify-content-end">
                            <div class="header-row">
                                <div class="header-nav header-nav-links order-2 order-lg-1">
                                    <div class="header-nav-main header-nav-main-square header-nav-main-effect-2 header-nav-main-sub-effect-1">
                                        <nav class="collapse " v-bind:class="{show: isActive}">
                                            <ul class="nav nav-pills" id="mainNav">
<!--                                                <li class="dropdown">-->
<!--                                                  <a href="https://register.codedive.pl/register/participant" class="register dropdown-item router-link-active">REGISTRATION</a>-->
<!--                                                </li>-->
                                                <li class="dropdown">
                                                    <router-link to="/legacy/" class="dropdown-item">Conference</router-link>
                                                </li>
                                                <li class="dropdown" v-if="nav_settings.show_agenda === true">
                                                    <router-link to="/legacy/agenda" class="dropdown-item">Agenda</router-link>
                                                </li>
                                                <li class="dropdown "  v-bind:class="{open: dropdown}">
                                                    <a class="dropdown-item dropdown-toggle" href="#">
                                                        Editions
                                                        <i class="fas fa-chevron-down" @click="showDropDown"></i>
                                                    </a>
                                                    <ul class="dropdown-menu">
                                                        <li v-for="nav in info" :key="nav.id">
                                                            <a class="dropdown-item" :href="'/edition/'+ nav.name">
                                                                {{ nav.name }}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li class="dropdown">
                                                    <router-link to="/legacy/code-of-conduct" class="dropdown-item">Code of Conduct</router-link>
                                                </li>
                                                <li class="dropdown">
                                                    <router-link to="/legacy/contact" class="dropdown-item">Contact</router-link>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                    <ul class="header-social-icons social-icons d-none d-sm-block">
                                        <li class="social-icons-facebook"><a href="https://www.facebook.com/CodeDiveWroclaw/" target="_blank" title="Facebook"><img src="./assets/img/facebook.svg" alt="Facebook"></a></li>
                                        <li class="social-icons-twitter"><a href="https://twitter.com/code_dive_pl" target="_blank" title="Twitter"><img src="./assets/img/twitter.svg" alt="Twitter"></a></li>
                                        <li class="social-icons-youtube"><a href="https://www.youtube.com/channel/UCU0Rt8VHO5-YNQXwIjkf-1g" target="_blank" title="youtube"><img src="./assets/img/youtube.svg" alt="Youtube"></a></li>
                                    </ul>
                                    <button class="btn header-btn-collapse-nav" data-toggle="collapse" data-target=".header-nav-main nav" @click="showNav">
                                        <i class="fas fa-bars"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <div v-if="sliders_web_ready==false" class="loader">
            <div class="container">
                <div class="row">
                    <div class="col-sm-1 mx-md-auto text-center">
                        <spring-spinner
                        :animation-duration="3000"
                        :size="60"
                        color="#124191"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="slider regular" v-if="$route.name != 'Edition'" >
                <agile
                    ref="slider"
                    :options="myOptions"
                    :slidesToShow="1"
                    :nav-buttons="true"
                    :autoplay-speed="5000"
                    :speed="2500"
                    fade="fade"
                    pause-on-hover="pause-on-hover"
                    pause-on-dots-hover="pause-on-dots-hover"
                    autoplay="autoplay">
                        <div class="slide" v-for="s in sliders_web" :key="s.id">
                            <div v-if="s.link == null || s.link == ''">
                                <img class="slide" :src="s.image_full_url" />
                            </div>
                            <div v-else>
                                <a :href="s.link">
                                    <img class="slide" :src="s.image_full_url" />
                                </a>
                            </div>
                        </div>

                        <template slot="prevButton"><i class="fas fa-chevron-left"></i></template>
                        <template slot="nextButton"><i class="fas fa-chevron-right"></i></template>
                </agile>
            </div>
            <div class="slider mobile" v-if="$route.name != 'Edition'">
                <agile
                    ref="slider_mobile"
                    :options="myOptions"
                    :slidesToShow="1"
                    :nav-buttons="true"
                    :autoplay-speed="5000"
                    :speed="2500"
                    fade="fade"
                    pause-on-hover="pause-on-hover"
                    pause-on-dots-hover="pause-on-dots-hover"
                    autoplay="autoplay">
                        <div class="slide" v-for="sm in sliders_mobile" :key="sm.id">
                            <div v-if="sm.link == null || sm.link == ''">
                                <img class="slide" :src="sm.image_full_url" />
                            </div>
                            <div v-else>
                                <a :href="sm.link">
                                    <img class="slide" :src="sm.image_full_url" />
                                </a>
                            </div>
                        </div>

                        <template slot="prevButton"><i class="fas fa-chevron-left"></i></template>
                        <template slot="nextButton"><i class="fas fa-chevron-right"></i></template>
                </agile>
            </div>
        </div>
<!--          <div class="cfp">-->
<!--            <div class="container">-->
<!--              <div class="row">-->
<!--                <div class="col-sm-6 text-center text-sm-left">-->
<!--                  <h3>Call for papers is open!</h3>-->
<!--                </div>-->
<!--                <div class="col-sm-6 text-sm-right text-center">-->
<!--                  <a href="/registration/cfp" class="btn btn-primary">Register now</a>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        <router-view v-bind:info="info" />
        <Footer />
    </div>
    </div>
</template>

<script>
import axios from 'axios'
import { VueAgile } from 'vue-agile'
import Footer from '@/components/Footer.vue'
import { SpringSpinner } from 'epic-spinners'

export default {
    components: {
        Footer,
        agile: VueAgile,
        SpringSpinner
    },
    data(){
        return{
            info: '',
            nav: '',
            myOptions: {

            },
            isActive: false,
            dropdown: false,
            sliders_web: '',
            sliders_web_ready: false,
            sliders_mobile: '',
            sliders_mobile_temp: '',
            nav_settings: '',
        }
    },
    methods: {
        showNav: function() {
            this.isActive = !this.isActive;
        },
        showDropDown: function() {
            this.dropdown = !this.dropdown;
        },
        getSlidersWeb(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/sliders_web')
                .then(response => {
                    this.sliders_web = response.data.data;
                })
                .then(response => {
                    for(let i = 0; i < this.sliders_web.length;i++){
                        axios.get(process.env.VUE_APP_BASE_URL+'/codedive/files/'+this.sliders_web[i].image)
                            .then(response => {
                                this.sliders_web[i].image_full_url = response.data.data.data.full_url
                            })
                    }
                    if (this.$refs.length) {
                      this.$nextTick(() => this.$refs.sliders_web.reload());
                    }

                    this.sliders_web_ready = true;
                })

        },
        getSlidersMobile(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/sliders_mobile')
                .then(response => {
                    this.sliders_mobile = response.data.data;
                })
                .then(response => {
                    for(let i = 0; i < this.sliders_mobile.length;i++){
                        axios.get(process.env.VUE_APP_BASE_URL+'/codedive/files/'+this.sliders_mobile[i].image)
                            .then(response => {
                                this.sliders_mobile[i].image_full_url = response.data.data.data.full_url
                            })
                    }
                    // this.$refs.slider_mobile.reload();
                })

        },
        getNavigationSettings(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/agenda_settings')
                .then(response => {
                    this.nav_settings = response.data.data[0];
                })
        },
        async getName(){
            const { data } = await axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/editions?filter[status]=published');
            this.info = data.data.reverse();
        }
    },
    created(){
        this.getName();
        this.getSlidersWeb();
        this.getSlidersMobile();
        this.getNavigationSettings();
    },
}
</script>
<style lang="scss">
    @import './assets/sass/fonts.scss';
    @import './assets/sass/variables.scss';
    @import './assets/vendor/bootstrap/css/bootstrap.min.css';
    @import './assets/vendor/fontawesome-free/css/all.min.css';
    @import './assets/vendor/simple-line-icons/css/simple-line-icons.min.css';
    @import './assets/css/theme.scss';
    @import './assets/css/theme-elements.scss';
    @import './assets/css/skins/default.scss';
    @import './assets/sass/app.scss';
    .cfp {
      background: #124191;
      .container{
        min-height: 115px;
        @media (max-width: 575px) {
          a {
            margin-bottom: 30px;
          }
        }
        @media (min-width: 576px) {
          a {
            margin-top: 30px;
            margin-bottom: 0;
          }
        }
        h3 {
          margin-top: 40px;
          color: white !important;
          text-transform: inherit;
        }
        a {
          height: 51px;
          width: 166px;
          font-size: 16px;
        }
      }
    }
</style>
